import React from "react";

function EpInlineLoader(props) {
  return (
    <div className="ep-inline-spinner">
      <div className="bounce1"></div>
      <div className="bounce2"></div>
      <div className="bounce3"></div>
    </div>
  );
}

export default EpInlineLoader;
